import {
    StepVariables,
    ToolContext,
} from "@services/tracking/types/trackingInfo/toolStepTrackingInfo";

type StepTypes = "start" | "submit";

const TOOL_NEWSLETTER_STEPS: Record<StepTypes, StepVariables> = {
    start: {
        stepName: "hubo nieuwsbrief",
        stepNumber: 1,
        placement: "promoties:nieuwsbrief",
        result: {},
        option: "",
    },
    submit: {
        stepName: "ingeschreven",
        stepNumber: 2,
        placement: "promoties:nieuwsbrief",
        result: {}, //customerId + store
        option: "",
    },
};

const TOOL_NEWSLETTER_CONTEXT: Readonly<ToolContext> = {
    name: "newsletter",
    type: "form",
};

export { TOOL_NEWSLETTER_STEPS, TOOL_NEWSLETTER_CONTEXT };
